<template>
	<div class="memberDiv">
		<div class="my_userinfo_cont">
			<!--  -->
			<div class="userinfoCont">
				<!-- 头像 -->
				<img class="header_img" v-if="userinfo.avatar" :src="userinfo.avatar" alt="">
				<div class="header_img  no_header_img" v-else @click="getAuth">
					<img class="no_img" src="../../assets/img/icon/no_img.png" alt="">
				</div>
				<!-- <van-image :src="userinfo.avatar" @click="getAuth" @error="error">
					<template v-slot:error>
						<img class="no_img" src="../../assets/img/icon/no_img.png" alt="">
					</template>
				</van-image> -->
				<div>
					<div class="user_name_cont">
						<!-- 昵称 -->
						<div class="user_name text-hide2" @click="getAuth">{{userinfo.nickname?userinfo.nickname:'微信用户'}}</div>
						<!-- 会员 -->
						<div class="user_grade" :class="{ 'ordinary': userinfo.membership == 0, 'Platinum': userinfo.membership == 2, 'Diamonds': userinfo.membership == 3 }" @click="getJumpVip(userinfo.membership)">
							{{userinfo.membership_name}}
						</div>
					</div>
					<div style="margin-top:10px;">
					<span class="user_major text-hide" v-if="userinfo.pc_name">{{userinfo.pc_name}}</span>
					</div>
				</div>
			</div>
			<!-- 我的错题、积分 -->
			<div class="my_conll">
				<div class="my_conll_img" @click="jump('/mywrong')">我的错题</div>
				<div class="my_conll_img img_s" @click="jump('/integral')">我的积分</div>
			</div>
		</div>
		<ul>
			<li class="me_li" v-for="(item,index) in myList" :key="index" @click="jump(item.url)">
				<img v-lazy="item.img" class="me_img"/>
				<div class="me_text">{{item.name}}</div>
				<!-- <span></span> -->
				<van-icon name="arrow" color="#D1D1D1"/>
			</li>
		</ul>

		<div class="return" @click="returnPage">退出登录</div>
  
		<!-- 老师二维码遮罩层 -->
		<van-overlay :show="show" @click="show = false" v-if="show">
			<div class=" w315 ps-45 b-radius-6 ptb-20 box-s bg_f text-center" @click.stop>
				<div class="fz-15 fw-500 c1">微信扫描二维码添加老师进行咨询</div>
				<img class="wh_126 mtb-31-ao" :src="userinfo.kf_img">
				<div class="wh_240_40 b-radius-6 c7 bg_49 fz-13 fw-500 m0-auto">长按图片保存到本地</div>
				<div class="iconfont icon-chahao icon" @click="show = false"></div>
			</div>
		</van-overlay>
	</div>
</template>
<script>
  import { userInfo } from '@/api/api.js'
	import {clear} from "@/utils/common.js";
	import { getCode } from '@/utils/wx'
	export default {
		components: {
			
		},
		data() {
			return {
				userinfo:{},
				membership: 0,
				myList:[
					{name:'个人资料',img:require('../../assets/img/my/user_icon_0.png'),url:'/personalinfo',},
					{name:'我的模拟考试',img:require('../../assets/img/my/user_icon_1.png'),url:'/imitmypract?flag=1'},
					{name:'我的模拟大赛',img:require('../../assets/img/my/user_icon_2.png'),url:'/mymidepractice?flag=1'},
					{name:'我的历年真题',img:require('../../assets/img/my/user_icon_3.png'),url:'/historymytext?flag=1'},
					{name:'兑换记录',img:require('../../assets/img/my/user_icon_4.png'),url:'/exchange'},
					{name:'客服',img:require('../../assets/img/my/user_icon_5.png'),url:''},
					{name:'兑换码',img:require('../../assets/img/my/user_icon_4.png'),url:'/exchangecode'},
				],
				show: false,
				img: ''
			};
		},
		created() {
			const searchParams = new URLSearchParams(window.location.search)
    		const urlCode = searchParams.get('code')
			if(urlCode){
        getCode().then(()=>{
			console.log('会员首页getCode','getCode')
          	this.initData()
				}).catch(()=>{})
			} else {
        		this.initData()
			}
		},
		methods: {
			async initData(){
        		const res = await userInfo()
				if(res.code == 1000){
					this.userinfo = res.data
					this.membership = res.data.membership
				}else {
					 this.$toast(res.msg)
				}
			},
			jump(url){
				getCode().then(()=>{
          		if(!url){
						this.show = true
					} else {
						this.$router.push(url)
					}
				}).catch(()=>{})
			},
      
			// 退出登录
			returnPage(){
				this.$dialog.confirm({
					title: '提示',
					message: '确认退出吗？',
				})
					.then(() => {
						// on confirm
						this.$store.commit('setToken', '')
						this.$store.commit('setClass', '')
						this.$store.commit('setClassName', '')
						this.$store.commit('setAuth', 0)
						this.$store.commit('setDay1', '')
						this.$store.commit('setDay2', '')
						this.$store.commit('setDay3', '')
						// clear()
						this.$router.replace('/login')
					})
					.catch(() => {
						// on cancel
					});
       
				
			},

			getJumpVip(membership){
				getCode().then(()=>{
          this.$router.push({ path:'/vip',query:{ type: membership } })
				}).catch(()=>{})
			},
			getAuth(){
				getCode().then(()=>{
				}).catch(()=>{})
			},
			error(e){
				this.userinfo.avatar = ''
			}
		}
	}
</script>
<style lang="less">
	.memberDiv{
		background:#FFF url(../../assets/img/my/bg.png) no-repeat;
		background-size:100% 250px;
	}
	.my_userinfo_cont{
		// .wh(100%,180px);
		
		.userinfoCont{
			.flexs();
			padding:16px 0 0 16px;
			box-sizing:border-box;
		}

		// /deep/.van-image {
		// 	.wh(60px,60px);
		// 	border-radius:50%;
		// 	margin-right:15px;
		// }
		// /deep/.van-image__img, /deep/.van-image__error, /deep/.van-image__loading {
		// 	.wh(60px,60px);
		// 	border-radius:50%;
		// }

		.header_img {
			width: 60px;
			height: 60px;
			// .wh(60px,60px);
			border-radius:50%;
			margin-right:15px;
		}

		.no_header_img {
			position: relative;
			background-color: #eee;
		}

		.no_img {
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
			// .wh(30px,30px);
			width: 30px;
			height: 30px;
		}
		.user_name_cont{
			.flexs();
			// height:32px;
		}
		.user_name{
			font-size: 16px;
			font-weight: 500;
			color: #333333;
			max-width: 175px
		}
		.user_grade{
			.wh(82px,28px);
			line-height:28px;
			background:url(../../assets/img/my/grade.png) no-repeat;
			background-size:100% 100%;
			text-indent:30px;
			margin-left:10px;
			font-size: 11px;
		}

		.Platinum {
			background:url('../../assets/img/my/Platinum.png') no-repeat;
			background-size:100% 100%;
		}

		.Diamonds {
			background:url('../../assets/img/my/Diamonds.png') no-repeat;
			background-size:100% 100%;
		}

		.ordinary {
			background:url('../../assets/img/my/ordinary.png') no-repeat;
			background-size:100% 100%;
		}
		.user_major{
			background: rgba(73, 124, 255, 0.1);
			padding:6px 10px;
			box-sizing:border-box;
			border-radius: 16px;
			color:@theme-color;
			font-size: 11px;
			// margin-top:25px;
			max-width: 270px;
			display: inline-block
		}
	}
	.my_conll{
		.flexs();
		margin:17px 9px 0 9px;
		.my_conll_img{
			.wh(178px,82px);
			background:url(../../assets/img/my/conll0.png) no-repeat;
			background-size:100% 100%;
			line-height:82px;
			font-size: 14px;
			font-weight: 600;
			color: #FFFFFF;
			text-indent:82px;
		}

		.img_s {
			background:url('../../assets/img/bg/jifen_mybg.png') no-repeat;
			background-size:100% 100%;
		}
	}
	.me_li{
		margin:0 16px;
		.wh(343px,60px);
		border-bottom:1px solid #EEEEEE;
		.flexs();
		.me_img{
			.wh(22px,22px);
		}
		.me_text{
			flex:1;
			margin:0 20px;
			font-size:14px;
			font-weight:600;
			color: #333333;
		}
	}

	.icon {
		position: absolute;
		left: 50%;
		bottom: -35px;
		transform: translateX(-50%);
		color: #fff;
		z-index: 20;
		font-size: 20px;
	}

	.return {
		padding: 20px 0 10px;
		color: #999;
		font-size: 14px;
		text-align: center;
	}
</style>


